import './modules/admission';

$(".kt_selectpicker").selectpicker();
